var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0H7L6.44943 2.20228C5.9349 2.33954 5.44758 2.54347 4.9973 2.80426L3.05026 1.63604L1.63605 3.05025L2.80427 4.99728C2.54348 5.44757 2.33954 5.93489 2.20228 6.44943L0 7V9L2.20228 9.55057C2.33954 10.0651 2.54347 10.5524 2.80427 11.0027L1.63605 12.9497L3.05026 14.364L4.99729 13.1957C5.44757 13.4565 5.93489 13.6605 6.44943 13.7977L7 16H9L9.55057 13.7977C10.0651 13.6605 10.5524 13.4565 11.0027 13.1957L12.9498 14.364L14.364 12.9497L13.1957 11.0027C13.4565 10.5524 13.6605 10.0651 13.7977 9.55057L16 9V7L13.7977 6.44943C13.6605 5.9349 13.4565 5.44758 13.1957 4.9973L14.364 3.05025L12.9498 1.63603L11.0027 2.80426C10.5524 2.54347 10.0651 2.33954 9.55057 2.20228L9 0ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6371a2ff3c880605d897abbab6e82443.svg";
export { ForwardRef as ReactComponent };